import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9fc9752"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Edit workstation Details", -1))
const _hoisted_3 = { class: "modal__content !tw-max-h-[600px] !tw-overflow-y-scroll !tw-pr-2 !tw-box-border !tw-border-0" }
const _hoisted_4 = { class: "uploade-wrapper md:!tw-h-[200px] md:!tw-w-[200px] rmd:!tw-h-[209px] rmd:!tw-w-[300px] rmd:!tw-rounded-[100%] rmd:!tw-overflow-hidden" }
const _hoisted_5 = { class: "right__wrapper" }
const _hoisted_6 = { class: "input__field__wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Workstation Name", -1))
const _hoisted_8 = {
  key: 0,
  class: "input__field__wrapper"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Company Register No", -1))
const _hoisted_10 = { class: "input__field__wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Postcode", -1))
const _hoisted_12 = {
  key: 0,
  class: "address__postcodes !tw-max-h-[280px]"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "address__postcodes_list__item" }
const _hoisted_15 = {
  key: 1,
  class: "error_msg"
}
const _hoisted_16 = { class: "tw-flex tw-justify-end tw-gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    className: ['edit_workstation_dialog'],
    width: "600px",
    height: "auto",
    "min-height": "400px",
    "max-height": "unset"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_v_btn, {
          icon: "mdi-close",
          onClick: $setup.onClickCloseButton
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_file_input, {
            class: _normalizeClass(["upload_file md:!tw-w-[200px] md:!tw-h-[200px] md:!tw-overflow-hidden md:!tw-top-[4px]", { 'added-img': $setup.imageUrl }]),
            "append-inner-icon": "mdi-image-plus",
            variant: "solo-filled",
            onChange: $setup.onFileChange,
            "onClick:clear": $setup.clearImageUrl
          }, null, 8, ["class", "onChange", "onClick:clear"]),
          _createVNode(_component_v_img, {
            class: "uploaded-img rmd:!tw-top-0",
            width: 200,
            "aspect-ratio": "16/9",
            cover: "",
            src: $setup.imageUrl
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_form, {
            ref: "workStationDetailsForm",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            rules: $setup.workStationDetailsFormRules
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_v_text_field, {
                  class: "input_field",
                  variant: "outlined",
                  modelValue: $setup.updatedUserInfo.workstationName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.updatedUserInfo.workstationName) = $event)),
                  rules: $setup.workStationDetailsFormRules.workstationName
                }, null, 8, ["modelValue", "rules"])
              ]),
              (
                $setup.activeUserWorkstation?.user?.userBusinessDetails?.type ===
                $setup.BusinessDetailTypeEnum.LIMITED_COMPANY
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_v_text_field, {
                      class: "input_field",
                      variant: "outlined",
                      modelValue: $setup.updatedUserInfo.companyRegistrationNo,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.updatedUserInfo.companyRegistrationNo) = $event)),
                      rules: $setup.workStationDetailsFormRules.companyRegistrationNo
                    }, null, 8, ["modelValue", "rules"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_v_text_field, {
                  class: "input_field_selector",
                  variant: "outlined",
                  "model-value": $setup.addressForm.postCode,
                  "onUpdate:modelValue": $setup.onPostCodeChange,
                  rules: $setup.workStationDetailsFormRules.postCode,
                  "append-inner-icon": "mdi-chevron-down"
                }, null, 8, ["model-value", "onUpdate:modelValue", "rules"]),
                ($setup.addressListFromPostcode?.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.addressListFromPostcode, ({ DPA }) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: _normalizeClass(["address__postcodes_list", { active: DPA?.UPRN === $setup.selectedPostCode }]),
                          key: DPA?.UPRN,
                          onClick: ($event: any) => ($setup.onSelectedAddress(DPA))
                        }, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(DPA?.ADDRESS), 1)
                        ], 10, _hoisted_13))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                ($setup.errorMessagePostcode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($setup.errorMessagePostcode), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  disabled: $setup.isProFileImageUploading,
                  onClick: $setup.onClickCloseButton
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_v_btn, {
                  class: "button button-purple",
                  onClick: $setup.onClickSaveButton,
                  disabled: $setup.isProFileImageUploading,
                  loading: $setup.isWorkStationDetailUpdating
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("SAVE")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled", "loading"])
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _: 1
  }))
}